import React from "react";
import { useLanguage } from "../context/LanguageContext";
import "../styles/NotFound.css";

const NotFound = () => {
  const { language } = useLanguage();

  return (
    <section className="not-found">
      <h2>
        {language === "ES" ? "Página no encontrada" : "Pàgina no trobada"}
      </h2>
      <p>
        {language === "ES"
          ? "La página que estás buscando no existe."
          : "La pàgina que busques no existeix."}
      </p>
    </section>
  );
};

export default NotFound;
